import { format, isValid, parse } from 'date-fns'
import { DATE_FORMATS } from '../../utils/constants/constant'

const toShortMonth = (month) => {
  if (typeof month !== 'string') return month
  const parsed = parse(month, DATE_FORMATS.MMM_yyyy, new Date())
  return isValid(parsed) ? format(parsed, DATE_FORMATS.MMM_YYYY_SHORT) : month
}

export const migrations = {
  // Revenue receivedMonth used to be persisted as 'September-2026'; the API expects 'Sep-2026'
  1: (state) => {
    const receivedMonth = state?.revenueList?.appliedFilter?.receivedMonth
    if (!Array.isArray(receivedMonth)) return state
    return {
      ...state,
      revenueList: {
        ...state.revenueList,
        appliedFilter: {
          ...state.revenueList.appliedFilter,
          receivedMonth: receivedMonth.map(toShortMonth),
        },
      },
    }
  },
}
